import React from 'react'
import { Grid, makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import Text from '../../../../atoms/Text'
import { useFormattingContext } from '../../../../organisms/FormattingProvider/FormattingContext'
import { useCheckPolicy } from '../../../../../hooks/index'
import { ACCOUNTS } from '../../../../../policies/admin'
import SectionHeader from '../../shared/SectionHeader'
import PerformanceDateInput from '../PerformanceDateInput'
import AccountCloseButton from '../AccountCloseButton'
import { AccountFormSection } from '../AccountFormProvider'

const useStyles = makeStyles((theme) => ({
}))

function AccountDates ({ account, disabled, onClosedAccount }) {
  const classes = useStyles()
  const { formatter } = useFormattingContext()
  const canCloseAccounts = useCheckPolicy(ACCOUNTS.closeAccounts)

  return (
    <AccountFormSection section='account_dates'>
      <SectionHeader text='Account Dates' />
      <Grid container className={classes.dateList} spacing={3}>
        <Grid item xs={6} sm={3} xl={2}>
          <Text customFontSize='18px' customFontWeight='600' text='Start Date' />
          <Text customFontSize='18px' text={formatter(account.startDate, '@MM/DD/YYYY')} />
        </Grid>
        <Grid item xs={6} sm={3} xl={2}>
          <Text customFontSize='18px' customFontWeight='600' text='Daily Start Date' />
          <Text customFontSize='18px' text={account.startDate ? formatter(account.dailyStartDate, '@MM/DD/YYYY') : 'Same as Start Date'} />
        </Grid>
        <Grid item xs={6} sm={3} xl={2}>
          <Text customFontSize='18px' customFontWeight='600' text='As Of Date' />
          <Text customFontSize='18px' text={formatter(account.asOfDate, '@MM/DD/YYYY')} />
        </Grid>
        <Grid item xs={6} sm={3} xl={2}>
          <PerformanceDateInput
            account={account}
            onSave={(val) => alert('todo')}
            disableEdit={disabled}
          />
        </Grid>
        <Grid item xs={6} sm={3} xl={2}>
          <Text customFontSize='18px' customFontWeight='600' text='Closed Date' />
          {canCloseAccounts && !account.closeDate ? (
            <AccountCloseButton
              disabled={disabled}
              account={account}
              onClosedAccount={onClosedAccount}
            />
          ) : (
            <Text customFontSize='18px' text={formatter(account.closeDate, '@MM/DD/YYYY')} />
          )}
        </Grid>
      </Grid>
    </AccountFormSection>
  )
}

AccountDates.propTypes = {
  account: PropTypes.shape({
    asOfDate: PropTypes.string,
    startDate: PropTypes.string,
    dailyStartDate: PropTypes.string,
    closeDate: PropTypes.string,
    performanceStartDate: PropTypes.string,
    onClosedAccount: PropTypes.func
  }),
  disabled: PropTypes.bool,
  onClosedAccount: PropTypes.func
}

export default AccountDates
